module.exports = __webpack_public_path__ + "static/media/events_07.119d164c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/JPEG/events_07.jpg
// module id = 5925
// module chunks = 0